import { fetchHowTo, getHowTo, getHowToError } from 'redux/modules/brand';
import { fetchHuggg, getHuggg } from 'redux/modules/huggg';

import { CMSContent } from 'components/misc';
import { connect } from 'react-redux';
import dict from 'config/dictionary';

const mapStateToProps = state => {
  return {
    content: getHowTo(state),
    error: getHowToError(state),
    huggg: getHuggg(state),
    title: dict.howTo.title
  };
};

export default connect(mapStateToProps, {
  fetchContent: fetchHowTo,
  fetchHuggg
})(CMSContent);
